import { render, staticRenderFns } from "./CustomerViewHistoryTab.vue?vue&type=template&id=2f6afec8&scoped=true"
import script from "./CustomerViewHistoryTab.vue?vue&type=script&lang=js"
export * from "./CustomerViewHistoryTab.vue?vue&type=script&lang=js"
import style0 from "./CustomerViewHistoryTab.vue?vue&type=style&index=0&id=2f6afec8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6afec8",
  null
  
)

export default component.exports